/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Directive, HostBinding } from '@angular/core';

/**
 * Twitter Bootstrap Grid row wrapper.
 * Used together with commonCol.
 *
 * Usage: @see {@link GridModule}
 */
@Directive({
    selector: '[commonRow]'
})
export class GridRowDirective {
    @HostBinding('class.common-grid-row') classRow = true;
}
